import { sanitize } from 'isomorphic-dompurify';

type CalloutMessageProps = {
  calloutMsg?: string;
  couponCalloutMessage?: string;
  hidden?: boolean;
};

export const CalloutMessage = ({
  calloutMsg,
  couponCalloutMessage,
  hidden = false,
}: CalloutMessageProps) => {
  if (hidden) return null;

  const sanitizedMessage = sanitize(calloutMsg || couponCalloutMessage || '');

  if (!sanitizedMessage) return null;

  return (
    <div className="absolute bottom-6 left-0 z-20 max-w-64 text-wrap break-words rounded-r-full bg-primary px-6 py-4 text-sm text-on-brand">
      <span dangerouslySetInnerHTML={{ __html: sanitizedMessage }} />
    </div>
  );
};
